import { render, staticRenderFns } from "./BomQingdan.vue?vue&type=template&id=1c039bfc"
import script from "./BomQingdan.vue?vue&type=script&lang=js"
export * from "./BomQingdan.vue?vue&type=script&lang=js"
import style0 from "./BomQingdan.vue?vue&type=style&index=0&id=1c039bfc&prod&lang=less&scoprd=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports